import { render } from "./RegisterCheckEmail.vue?vue&type=template&id=b12ae300&scoped=true"
import script from "./RegisterCheckEmail.vue?vue&type=script&lang=js"
export * from "./RegisterCheckEmail.vue?vue&type=script&lang=js"

import "./RegisterCheckEmail.vue?vue&type=style&index=0&id=b12ae300&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b12ae300"]])

export default __exports__